import { useTranslation } from "react-i18next"
import { MouseEvent, useState } from "react"
import { useStore } from "../../../contexts/store"
import { PodClass } from "../../../classes/Pod"

import SettingsDialog from "./SettingsDialog"
import UxIcon from "../../Elements/UxIcon"
import { Button } from "@mui/material"


const AddFolderButton = () => {
  const { t } = useTranslation()
  const { podStore } = useStore()
  const [openSettings, setOpenSettings] = useState(false)
  const pod: PodClass | null = podStore.pod
  if(pod === null) return null

  const handleOpenSettings = (e: MouseEvent) => {
    setOpenSettings(true)
    e.stopPropagation()
  }

  return (
    <>
      <Button variant='outlined' onClick={(e: MouseEvent) => handleOpenSettings(e)} startIcon={
        <UxIcon id="podAddFolder" />
      }>
        {t('Add folder')}
      </Button>
      <SettingsDialog handleClose={() => setOpenSettings(false)} itemType="folder" item={null} open={openSettings}  pod={pod} />
    </>
  )
}

export default AddFolderButton